import classNames from 'classnames'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { HelpButton, HelpSection } from 'legacy/lut/components/widgets/public/partner360/helpButton'
import { IWidgetHeaderProps } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/models'
import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'
import { selectPartnerAccess } from 'legacy/lut/features/partner360/configuration'
import { useSelector } from 'react-redux'

import styles from './WidgetHeaderWithHelpButton.module.scss'

interface IProps extends IWidgetHeaderProps {
  section: HelpSection
  align?: 'left' | 'center' | 'right'
}

export const WidgetHeaderWithHelpButton = ({ section, align, children, ...props }: IProps) => {
  const { isGlobal } = useSelector(selectPartnerAccess)

  return (
    <div className={classNames(styles.root, { [styles[`align-${align}`]]: align })}>
      <WidgetHeader {...props} className={styles.widgetHeader}>
        {children}
      </WidgetHeader>
      <RenderWhen condition={!isGlobal}>
        <HelpButton section={section} className={styles.icon} />
      </RenderWhen>
    </div>
  )
}
